<template>
  <div>
    <PageTable :items="rows" :columns="columns" :is-loading="isLoading" @row-click="handleRowClick">
      <template #type="{ item }">
        {{ enumToHumanReadable(item.type) }}
      </template>

      <template #status="{ item }">
        <label :class="['badge', getStatusClass(item.status)]">
          {{ item.status }}
        </label>
      </template>

      <template #chevron>
        <div class="text-right">
          <i class="fas fa-chevron-right text-muted"></i>
        </div>
      </template>
    </PageTable>
  </div>
</template>

<script>

import PageTable from "../layouts/PageTable.vue";
import {enumToHumanReadable} from "../../utils/utils";

export default {
  components: {
    PageTable,
  },
  props: {
    rows: Array,
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    enumToHumanReadable,
    viewInvoice(id) {
      this.$router.push(`/contacts/${id}/edit`);
    },
    handleRowClick(item) {
      this.viewInvoice(item.id);
    },
    getStatusClass(status) {
      return {
        DRAFT: 'badge-secondary',
        UNPAID: 'badge-danger',
        ACTIVE: 'badge-success',
      }[status] || 'badge-info';
    }
  },
  computed: {
    columns() {
      return [
        {
          label: 'First Name',
          key: 'firstName',
        },
        {
          label: 'Last Name',
          key: 'lastName',
        },
        {
          label: 'Type',
          key: 'type',
        },
        {
          label: 'Status',
          key: 'status'
        },
        {
          label: '',
          key: 'chevron',
          align: 'right'
        }
      ];
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/contacts/ContactsTable.vue